// US States: abbreviation → full name
export const US_STATES = {
  AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
  CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', FL: 'Florida', GA: 'Georgia',
  HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa',
  KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland',
  MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri',
  MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey',
  NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio',
  OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina',
  SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont',
  VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming',
  DC: 'District of Columbia'
};

// Reverse lookup: full name (lowercase) → abbreviation
export const STATE_NAME_TO_ABBR = Object.entries(US_STATES).reduce((acc, [abbr, name]) => {
  acc[name.toLowerCase()] = abbr;
  return acc;
}, {});

// State options for dropdown: [{ value, label }]
export const STATE_OPTIONS = [
  { value: '', label: 'Select State' },
  { value: 'Remote', label: 'Remote' },
  ...Object.entries(US_STATES).map(([abbr, name]) => ({ value: abbr, label: `${abbr} — ${name}` }))
];

// Preset major US cities (~200) organized by state
export const PRESET_CITIES = [
  'New York', 'Los Angeles', 'Chicago', 'Houston', 'Phoenix', 'Philadelphia', 'San Antonio', 'San Diego',
  'Dallas', 'San Jose', 'Austin', 'Jacksonville', 'Fort Worth', 'Columbus', 'Charlotte', 'Indianapolis',
  'San Francisco', 'Seattle', 'Denver', 'Washington', 'Nashville', 'Oklahoma City', 'El Paso', 'Boston',
  'Portland', 'Las Vegas', 'Memphis', 'Louisville', 'Baltimore', 'Milwaukee', 'Albuquerque', 'Tucson',
  'Fresno', 'Mesa', 'Sacramento', 'Atlanta', 'Kansas City', 'Colorado Springs', 'Omaha', 'Raleigh',
  'Virginia Beach', 'Long Beach', 'Miami', 'Oakland', 'Minneapolis', 'Tulsa', 'Tampa', 'Arlington',
  'New Orleans', 'Wichita', 'Cleveland', 'Bakersfield', 'Aurora', 'Anaheim', 'Honolulu', 'Santa Ana',
  'Riverside', 'Corpus Christi', 'Lexington', 'Stockton', 'St. Louis', 'St. Paul', 'Pittsburgh',
  'Cincinnati', 'Anchorage', 'Henderson', 'Greensboro', 'Plano', 'Newark', 'Lincoln', 'Orlando',
  'Irvine', 'Toledo', 'Jersey City', 'Chula Vista', 'Durham', 'Laredo', 'Madison', 'Chandler',
  'Buffalo', 'Lubbock', 'Scottsdale', 'Reno', 'Glendale', 'Gilbert', 'Winston-Salem', 'North Las Vegas',
  'Norfolk', 'Chesapeake', 'Garland', 'Irving', 'Hialeah', 'Fremont', 'Boise', 'Richmond',
  'Baton Rouge', 'Spokane', 'Des Moines', 'Tacoma', 'San Bernardino', 'Modesto', 'Fontana',
  'Santa Clarita', 'Moreno Valley', 'Birmingham', 'Oxnard', 'Rochester', 'Port St. Lucie',
  'Grand Rapids', 'Huntsville', 'Salt Lake City', 'Frisco', 'Yonkers', 'Amarillo', 'Glendale',
  'Huntington Beach', 'McKinney', 'Montgomery', 'Augusta', 'Aurora', 'Akron', 'Little Rock',
  'Tempe', 'Overland Park', 'Brownsville', 'Tallahassee', 'Mobile', 'Knoxville', 'Shreveport',
  'Worcester', 'Newport News', 'Providence', 'Fort Lauderdale', 'Chattanooga', 'Oceanside',
  'Garden Grove', 'Rancho Cucamonga', 'Santa Rosa', 'Sioux Falls', 'Detroit', 'Stamford',
  'Bridgeport', 'New Haven', 'Hartford', 'Provo', 'Ann Arbor', 'Boulder', 'Cambridge',
  'Palo Alto', 'Mountain View', 'Sunnyvale', 'Redmond', 'Bellevue', 'Naperville', 'Evanston',
  'Hoboken', 'Santa Monica', 'Pasadena', 'Alexandria', 'Bethesda', 'Tysons', 'McLean',
  'Princeton', 'Stamford', 'Greenwich', 'Wilmington', 'Charleston', 'Savannah', 'Asheville',
  'Chapel Hill', 'Charlottesville', 'Ithaca', 'Burlington', 'Columbia', 'Athens', 'Gainesville'
];

// Smart match: checks if a search query matches a location string
// Handles "Wisconsin" matching "WI", "WI" matching "Wisconsin", partial matches, etc.
export function locationMatchesQuery(location, query) {
  if (!location || !query) return false;
  const loc = location.toLowerCase();
  const q = query.toLowerCase().trim();

  // Direct substring match
  if (loc.includes(q)) return true;

  // Extract state abbr from location (first part before ·)
  const parts = location.split('·').map(p => p.trim());
  const stateAbbr = parts[0]?.toUpperCase();
  const city = parts[1] || '';

  // If query is a full state name, match against abbreviation
  if (STATE_NAME_TO_ABBR[q] && stateAbbr === STATE_NAME_TO_ABBR[q]) return true;

  // If query is a 2-letter abbreviation, match against full name
  const upperQ = query.toUpperCase().trim();
  if (US_STATES[upperQ] && stateAbbr === upperQ) return true;

  // Partial full name match: "wisc" → matches WI (Wisconsin)
  const fullName = US_STATES[stateAbbr]?.toLowerCase() || '';
  if (fullName && fullName.includes(q)) return true;

  // City match
  if (city && city.toLowerCase().includes(q)) return true;

  // Remote match
  if (loc === 'remote' && q === 'remote') return true;

  return false;
}
